var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { markRaw, createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "m9 11l-4 4l4 4m-4-4h11a4 4 0 0 0 0-8h-1"
    }, null, -1)
  ]));
}
__name(render, "render");
const arrowBack = markRaw({ name: "tabler-arrow-back", render });
export {
  arrowBack as default
};
//# sourceMappingURL=arrow-back.js.map
